export default {
  Home: {
    title: "Projetsolaire.com {'|'} Install Solar Panels with RGE Professional",
    description:
      "With projetsolaire.com, get 3+ free estimates at up to 40% below market prices, from thousands of photovoltaic professionals and self-consumption battery specialists.",
    //title: "Projetsolaire.com {'|'} Solar Energy Community Platform",
    //description: "With projetsolaire.com, get 3+ free photovoltaic estimates at up to 40% below market prices, from solar panel professionals and self-consumption battery installers.",
  },
  LeadFlow: {
    title: "Solar Potential - Hourly 25-Year Study {'|'} projetsolaire.com",
    description:
      "Discover your photovoltaic self-consumption with hourly analysis of your Linky meter history. Free and without commitment. Zero cold calling.",
  },
  ResaleAgreements: {
    title: "Compare alternatives to EDF OA",
    description:
      "Find alternatives to EDF OA. Choose between a contract or a virtual battery and let projetsolaire guide you through the process.",
  },
  About: {
    title: "Commitments of the French Solar Leader {'|'} projetsolaire.com",
    description:
      "Discover the mission and team of France’s #1 photovoltaic engineering consultancy, and its vision for IT at the service of the French solar sector.",
  },
  SolarLeasingHomeOwners: {
    title: "Solar panel leasing for homeowners {'|'} projetsolaire.com",
    description:
      "Solar with no upfront cost. Fixed monthly payment, installation and warranty included. Get a free personalized offer.",
  },
  SellSurplusEnergy: {
    title: "Sell your surplus solar energy {'|'} projetsolaire.com",
    description:
      "Earn more than feed-in tariffs by selling directly to your local community. We handle the complexity, you receive the payments.",
  },
  CommunitySolarConsumer: {
    title: "Join a solar community near you {'|'} projetsolaire.com",
    description:
      "Access cheaper local solar energy with no panels required. Join a community near you and reduce your electricity bill while supporting local renewable energy.",
  },
  HelpHome: {
    title: "User Manual and Tips - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  LearnCenter: {
    title: "User Manual and Tips - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpHouseholder: {
    title: "Homeowner Assistance - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderYourAccountGuideParentAll: {
    title: "Your Online Portal - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderPaymentsGuideParentAll: {
    title: "Payments, Pricing and Refunds - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderPresentationGuideParentAll: {
    title: "Choosing your Solar System - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderQuotingGuideParentAll: {
    title: "Choose your Custom Estimate - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderTechnicalVisitGuideParentAll: {
    title: "Validate Feasibility - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderContractGuideParentAll: {
    title: "Investing in Solar - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderAdministrationGuideParentAll: {
    title:
      "Carrying out Administrative Tasks - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderInstallationGuideParentAll: {
    title: "Installation & Commissioning - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideHouseholderLegalGuideParentAll: {
    title: "Legal Mentions - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpInstaller: {
    title: "Customer Service for Pros - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerYourAccountGuideParentAll: {
    title: "Your Online Account - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerPresentationGuideParentAll: {
    title: "Online PV Studies - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerQuotingGuideParentAll: {
    title: "Lead Generation - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerAdministrationGuideParentAll: {
    title:
      "Automated Administrative Management - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerHardwareGuideParentAll: {
    title: "Equipment Planning - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerPaymentsGuideParentAll: {
    title: "Payments, Pricing and Refunds - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerProjectManagementGuideParentAll: {
    title: "Your Solar Projects - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerPostInstallationGuideParentAll: {
    title: "Post-Installation Service - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  HelpGuideInstallerLegalGuideParentAll: {
    title: "Legal Mentions - Help Center {'|'} projetsolaire.com",
    description:
      "Need help or want to contact us? Find assistance, documentation, articles, and videos about web and mobile features and services.",
  },
  Blog: {
    title: "Tips, Guides, Info Center {'|'} projetsolaire.com",
    description:
      "Read all our advice to finance, optimize and maintain your solar panels. Self-consumption, energy savings, grants, and procedures.",
  },
  BlogHome: {
    title: "Tips, Guides, Info Center {'|'} projetsolaire.com",
    description:
      "Our expertise to finance, optimize and maintain your solar panels and storage batteries. Self-consumption, savings, grants, and procedures.",
  },
  BlogSeries: {
    title: "Tips, Guides, Info Center {'|'} projetsolaire.com",
    description:
      "Our expertise to finance, optimize and maintain your solar panels and storage batteries. Self-consumption, savings, grants, and procedures.",
  },
  BlogArticle: {
    title: "Tips, Guides, Info Center {'|'} projetsolaire.com",
    description:
      "Our expertise to finance, optimize and maintain your solar panels and storage batteries. Self-consumption, savings, grants, and procedures.",
  },
  CareerHome: {
    title: "Climate Impact | Careers at projetsolaire",
    description:
      "Want to finally make an impact on the climate? Join us to accomplish something big.",
  },
  CareerJobPosts: {
    title: "Open Positions | Careers at projetsolaire",
    description:
      "Want to finally make an impact on the climate? Join us to accomplish something big.",
  },
  CareerJobPost: {
    title: "Opportunities & Positions | Careers at projetsolaire",
    description:
      "Join us to accomplish something big. We are shaping the future of clean and decentralized energy in France, among the world’s most beautiful landscapes.",
  },
  CareerJobPostApply: {
    title: "Opportunities & Positions | Careers at projetsolaire",
    description:
      "Join us to accomplish something big. We are shaping the future of clean and decentralized energy in France, among the world’s most beautiful landscapes.",
  },
  AmbassadorsHome: {
    title:
      "Refer & Earn €500 - Ambassador Program {'|'} projetsolaire.com",
    description:
      "Join our solar ambassador program. Refer your friends and earn €500 per installation. Contribute to the energy transition while earning money.",
  },
  AmbassadorsLead: {
    title: "Talk about solar and earn money {'|'} projetsolaire.com",
    description:
      "Earn thousands of euros with projetsolaire by word of mouth: get your friends’ and neighbors’ electricity bills, then refer them to professionals.",
  },
  InstallerHome: {
    title:
      "Projetsolaire.com {'|'} #1 All-in-One Photovoltaic Management",
    description:
      "Sizing and admin platform for solar panel installers, RGE professionals, PV fitters, developers of BT and HTA photovoltaic installations.",
  },
  InstallerSolarLeasing: {
    title: "Solar leasing for installers {'|'} projetsolaire.com",
    description:
      "Offer monthly solar subscriptions to close more deals with zero upfront cost and quick approvals.",
  },
  InstallerChangelog: {
    title: "Changelog {'|'} projetsolaire.com",
    description:
      "Discover the latest features and improvements to the projetsolaire platform.",
  },
  InstallerMobileAppIOS: {
    title: "iOS App - Coming Soon {'|'} projetsolaire.com",
    description:
      "Stay tuned for the release of our exciting new mobile app. Be the first to experience the future of solar collaboration on your iPhone.",
  },
  InstallerAdministration: {
    title: "#1 for PV Administrative Tasks {'|'} projetsolaire.com",
    description:
      "Photovoltaic administrative formalities expert. Delegate and follow your urban planning, Enedis or ELD, Consuel, EDF OA or virtual battery files.",
  },
  InstallerAdministrationMayor: {
    title: "DP & PC for Town Hall Authorization {'|'} projetsolaire.com",
    description:
      "Urban planning permit for solar: prior declaration or building permit.",
  },
  InstallerAdministrationGridConnection: {
    title:
      "Solar Grid Connection Request BT/HTA {'|'} projetsolaire.com",
    description:
      "Enedis or ELD process with PTF for commissioning. EDF OA or virtual battery or ARPE processes.",
  },
  InstallerAdministrationConsuel: {
    title:
      "Blue & Violet Consuel Compliance Certificate {'|'} projetsolaire.com",
    description:
      "Software & services for obtaining Consuel AC, single-line diagram, SC144, and inspection.",
  },
  InstallerAdministrationServiceOutline: {
    title:
      "Bespoke Solution for Administrative Formalities {'|'} projetsolaire.com",
    description:
      "Photovoltaic administrative formalities expert. Delegate and follow your urban planning, Enedis or ELD, Consuel, EDF OA or virtual battery files.",
  },
  InstallerDigitalSalesTools: {
    title: "Solar PV Design Software {'|'} projetsolaire.com",
    description:
      "Photovoltaic studies with hourly Linky meter consumption data, shading mask for RGE audit, in white label.",
  },
  InstallerQuote: {
    title: "Sales-Integrated Quote Management {'|'} projetsolaire.com",
    description:
      "Create and send quotes in seconds. Attach quotes to presentations, customize pricing, collect e-signatures, and process payments all in one seamless workflow.",
  },
  InstallerCustomerPortal: {
    title: "Branded Online Customer Portals {'|'} projetsolaire.com",
    description:
      "Increase conversion rates and reduce back-and-forth with a professional, white-label portal that keeps your customers informed every step of the way. Real-time progress tracking, document hub, and seamless integration.",
  },
  InstallerDesign: {
    title: "Design with projetsolaire",
    description:
      "We work with Aurora Solar to provide you the most versatile, high-quality solution for your clients’ system sizing.",
  },
  InstallerFindNewClients: {
    title: "PV Leads Without Commissions {'|'} projetsolaire.com",
    description:
      "Online tender platform for photovoltaic projects. The installer chooses the price and equipment. Technical inspection is mandatory.",
  },
  InstallerCaseStudiesHomeOverview: {
    title: "Case Studies & Testimonials All Sizes {'|'} projetsolaire.com",
    description:
      "Reviews of projetsolaire from professionals, installers, and developers; use cases for HTA, BT >36, residential projects.",
  },
  InstallerCaseStudiesHomeAll: {
    title: "All Pro Testimonials & Reviews {'|'} projetsolaire.com",
    description:
      "Reviews of projetsolaire from professionals, installers, and developers; use cases for HTA, BT >36, residential projects.",
  },
  Pricing: {
    title: "Pricing and Costs for Professionals {'|'} projetsolaire.com",
    description:
      "Projetsolaire pricing grid & digital services, administrative processes, studies, lead generation, project management platform.",
  },
  ToolsHome: {
    title: "Free Solar Installation Tools {'|'} projetsolaire.com",
    description:
      "France's #1 PV engineering firm develops online tools and simulators, free and open access for solar panel installation.",
  },
  ToolEnedisConstructionCost: {
    title:
      "Enedis Grid Work Cost Simulator - Free Tool {'|'} projetsolaire.com",
    description:
      "Calculate the cost of BT and HTA grid reinforcement by Enedis. Alternative to the PTF quote for photovoltaic grid connection requests.",
  },
  ToolCarbonModelCalculator: {
    title:
      "Solar CO2e Impact Calculator - Free Tool {'|'} projetsolaire.com",
    description:
      "France's #1 PV engineering firm develops online tools and simulators, free and open access for solar panel installation.",
  },
  ToolQuoteChecker: {
    title:
      "Check PV Quotes - Free Tool {'|'} projetsolaire.com",
    description:
      "France's #1 PV engineering firm develops online tools and simulators, free and open access for solar panel installation.",
  },
  ToolHistoricalMonumentChecker: {
    title:
      "Urbanism & Heritage Zone Checker - Free Tool {'|'} projetsolaire.com",
    description:
      "France's #1 PV engineering firm develops online tools and simulators, free and open access for solar panel installation.",
  },
  Support: {
    title: "Customer Service & Contact {'|'} projetsolaire.com",
    description:
      "Talk with our teams today. 360° customer service, available via chat, email, phone, SMS, and video. Available all business days, year-round.",
  },
  SupportSchedule: {
    title: "Customer Service & Contact {'|'} projetsolaire.com",
    description:
      "Talk with our teams today. 360° customer service, available via chat, email, phone, SMS, and video. Available all business days, year-round.",
  },
  DynamicFormAdministration: {
    title: "Online Form for PV Administrative Files",
    description:
      "Enter the information in the online form to successfully submit your file to French administration.",
  },
  DynamicFormLead: {
    title: "Online Form for Solar Techno-Economic Study",
    description:
      "Enter the requested information to successfully run the profitability study for your self-consumption project.",
  },
  DynamicFormEnedisConsumptionPermission: {
    title: "Online Consent Form for Linky Data",
    description:
      "Enter the requested information to successfully analyze your site's hourly self-consumption.",
  },
  GetBestPrice: {
    title: "Get best price / Quote {'|'} projetsolaire.com",
    description:
      "Get the best price for your solar project. Share your quote or upload your file; we will get back to you soon.",
  },
  SignUp: {
    title: "Sign Up {'|'} projetsolaire.com",
    description:
      "France's #1 photovoltaic consulting firm has developed the first tender platform for solar panel installation and admin processes.",
  },
  SignUpCallback: {
    title: "Sign-Up Confirmation {'|'} projetsolaire.com",
    description:
      "France's #1 photovoltaic consulting firm has developed the first tender platform for solar panel installation and admin processes.",
  },
  EnableAccountCallback: {
    title: "Account Activation {'|'} projetsolaire.com",
    description:
      "France's #1 photovoltaic consulting firm has developed the first tender platform for solar panel installation and admin processes.",
  },
  SignIn: {
    title: "Sign In {'|'} projetsolaire.com",
    description:
      "France's #1 photovoltaic consulting firm has developed the first tender platform for solar panel installation and admin processes.",
  },
  AdminSignIn: {
    title: "Private Access",
    description:
      "Never share your password. Your password is only ever requested at login.",
  },
  SupplierSignIn: {
    title: "Sign In - Supplier Portal {'|'} projetsolaire.com",
    description: "Sign In - Supplier description",
  },
  AmbassadorSignIn: {
    title: "Sign In - Ambassadors Portal {'|'} projetsolaire.com",
    description: "Sign In - Ambassador description",
  },
  ArchitectSignIn: {
    title: "Sign In - Architect Portal {'|'} projetsolaire.com",
    description: "Sign In - Architect description",
  },
  VirtualBatteryProviderSignIn: {
    title: "Sign In - Virtual Battery Portal {'|'} projetsolaire.com",
    description: "Sign In - Virtual Battery description",
  },
  ResetPassword: {
    title: "Password Reset {'|'} projetsolaire.com",
    description: "Password Reset description",
  },
  ResetPasswordSupplier: {
    title: "Password Reset - Suppliers {'|'} projetsolaire.com",
    description: "Password Reset - Suppliers description",
  },
  ResetPasswordCallback: {
    title: "Password Reset - Callback",
    description: "The platform is secure.",
  },
  InviteCallbackInstaller: {
    title: "Company Account Invitation {'|'} projetsolaire.com",
    description:
      "Personal account for managing photovoltaic projects. Provided free of charge by the French digital engineering firm projetsolaire.com",
  },
  InviteCallbackArchitect: {
    title: "Company Account Invitation {'|'} projetsolaire.com",
    description:
      "Personal account for managing photovoltaic projects. Provided free of charge by the French digital engineering firm projetsolaire.com",
  },
  InviteCallbackVirtualBatteryProvider: {
    title: "Company Account Invitation {'|'} projetsolaire.com",
    description:
      "Personal account for managing photovoltaic projects. Provided free of charge by the French digital engineering firm projetsolaire.com",
  },
  InviteCallbackSupplier: {
    title: "E-commerce Portal Invitation {'|'} projetsolaire.com",
    description:
      "E-commerce account for selling photovoltaic equipment online. Provided free of charge by the French digital engineering firm projetsolaire.com",
  },
  InviteCallbackUser: {
    title:
      "Customer Space Invitation for Your Solar Project {'|'} projetsolaire.com",
    description:
      "Customer portal for online monitoring of your solar project. Provided free of charge by the French digital engineering firm projetsolaire.com",
  },
  ReportsHome: {
    title: "Solar Report for France {'|'} projetsolaire.com",
    description:
      "France’s #1 photovoltaic consulting publishes its annual report. Discover the trends, info, and data for the PV sector.",
  },
  Reports2023: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023Home: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023Introduction: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023MarketEvolution: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023BarometreConsommateurs: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023Hardware: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023Reglementation: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023Ecodelinquance: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023Co2EnergyMix: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  Reports2023AboutProjetsolaire: {
    title: "Annual Solar Report France {'|'} projetsolaire.com",
    description:
      "Discover the latest in solar energy. Trends, info, and data for the photovoltaic and storage sector in France.",
  },
  HardwareMarketplaceShopHome: {
    title:
      "Online Solar Equipment Shopping & Distribution {'|'} projetsolaire.com",
    description:
      "Discover competitive prices, 100% online for PV modules, inverters, batteries, solar energy equipment.",
  },
  HardwareMarketplace: {
    title: "Order your Solar Equipment online  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceAbout: {
    title: "Order your Solar Equipment online  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceSupport: {
    title: "Customer Service for Online Orders {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceCompare: {
    title: "Compare Solar Equipment Online {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceCollection: {
    title: "Order your Solar Equipment online  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceCollectionManufacturer: {
    title: "Compare Solar Equipment Brands  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceShopManufacturers: {
    title: "Compare Solar Equipment Brands  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceShopSuppliers: {
    title: "Compare Solar Equipment Offers {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceShopSupplier: {
    title: "Compare Solar Equipment Offers {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceShopProducts: {
    title: "Order your Solar Equipment online  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceShopProduct: {
    title: "Order your Solar Equipment online  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt is the e-commerce webshop for PV and storage professionals: modules, inverters, mounting systems, batteries.",
  },
  HardwareMarketplaceCompareParent: {
    title:
      "Online Solar Equipment Shopping & Distribution {'|'} projetsolaire.com",
    description:
      "Discover competitive prices, 100% online for PV modules, inverters, batteries, solar energy equipment.",
  },

  InstallerUseCaseSmall: {
    title:
      "PV Software Sales, DP, Consuel for Professionals {'|'} projetsolaire.com",

    description:
      "Photovoltaic management app for RGE professionals. Linky data, layout, profitability studies, quoting, admin, all in one tool.",
  },

  InstallerUseCaseRegional: {
    title:
      "PV Software for SME Photovoltaic Installers {'|'} projetsolaire.com",

    description:
      "CRM and ERP for project management. Linky data, layout and sizing, profitability studies with storage, quoting, calendar, order management, all in one tool.",
  },

  InstallerUseCaseNational: {
    title:
      "Software for Large Company PV Project Management {'|'} projetsolaire.com",

    description:
      "All-in-one platform for PV and storage. Linky data, sizing, profitability studies, permits, grid connection, all in one tool.",
  },

  InstallerUseCaseSelfInstallation: {
    title:
      "PV Software with Simulator, Sales, DP, Enedis {'|'} projetsolaire.com",

    description:
      "White-label PV CRM & ERP. Linky data, layout, custom profitability studies, quoting, admin, all in one tool.",
  },

  InstallerUseCaseFranchise: {
    title: "PV Sales & Franchise Management Software {'|'} projetsolaire.com",

    description:
      "PV CRM and ERP for franchise network management. Linky data, sizing, profitability studies, quoting, order management, all in one tool.",
  },

  InstallerUseCaseDeveloper: {
    title:
      "PV Development Software for Investors {'|'} projetsolaire.com",

    description:
      "CRM & ERP for PV project monitoring and SPV management. Linky data, sizing and yield, feasibility/preliminary design, contracts, grid connection, commissioning, all in one tool.",
  },

  InstallerUseCaseCommercialRegie: {
    title:
      "Commercial agency network for PV installation subcontractors {'|'} projetsolaire.com",
    description:
      "Principal contractor looking for solar installers? Access the projetsolaire network: subcontracting, tooling, and project management in one platform.",
  },

  InstallerUseCaseManufacturerSupplier: {
    title:
      "Hardware supplier for solar and storage installers {'|'} projetsolaire.com",
    description:
      "Are you a hardware manufacturer or vendor? Discover how to sell directly to thousands of installers with projetsolaire.",
  },

  InstallerUseCaseEnergySupplier: {
    title:
      "Energy supplier in solar {'|'} projetsolaire.com",
    description:
      "Do you offer EMS solutions? Discover how energy suppliers use projetsolaire to innovate faster.",
  },

  InstallerUseCasesHome: {
    title:
      "Case Studies for PV CRM/ERP Software {'|'} projetsolaire.com",
    description:
      "Discover the suite of management and monitoring solutions used by our hundreds of professional, installer and developer clients.",
  },
  InstallerHostedPageParent: {
    title:
      "Solar Panel Company in {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Choose a local company. Reduce your electricity bill with the latest generation of solar panels and batteries.",
  },
  InstallerHostedPageOnboard: {
    title:
      "Solar Panel Company in {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Choose a local company. Reduce your electricity bill with the latest generation of solar panels and batteries.",
  },
  InstallerHostedPageOnboardCallback: {
    title:
      "Solar Panel Company in {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Choose a local company. Reduce your electricity bill with the latest generation of solar panels and batteries.",
  },
  InstallerHostedPageSignIn: {
    title:
      "Solar Panel Company in {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Choose a local company. Reduce your electricity bill with the latest generation of solar panels and batteries.",
  },
  InstallerHostedPageInviteCallback: {
    title:
      "Solar Panel Company in {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Choose a local company. Reduce your electricity bill with the latest generation of solar panels and batteries.",
  },
  MyLight150MySmartBattery: {
    title: "MySmartBattery by mylight150: Pricing & Terms",
    description:
      "Compare the mylight150 virtual battery offer with control unit with other photovoltaic solar energy offers.",
  },
  MyLight150MyBattery: {
    title: "MyBattery by mylight150: Pricing & Terms",
    description:
      "Compare the mylight150 unlimited virtual battery offer (no hardware) with other photovoltaic solar energy offers.",
  },
  UrbanSolarEnergyBatteryIndividuals: {
    title: "Virtual Storage by Urban Solar Energy: Pricing & Terms",
    description:
      "Compare the Urban Solar Energy unlimited/no hardware virtual battery offer with other photovoltaic solar energy offers.",
  },
  UrbanSolarEnergyBatteryVirtualProfessional: {
    title: "Virtual Storage for Pros by Urban Solar: Pricing & Terms",
    description:
      "Compare the Urban Solar unlimited virtual battery professional offer with other photovoltaic solar energy offers.",
  },
  UrbanSolarEnergyBoostProductionLessThan36kva: {
    title: "Boost My Surplus with Urban Solar Energy: Pricing & Terms",
    description:
      "Compare Urban Solar Energy’s (<36 kVA) surplus buyback offer with other photovoltaic solar energy offers.",
  },
  UrbanSolarEnergyBoostProductionPlus36kva: {
    title: "Boost My Surplus with Urban Solar Energy: Pricing & Terms",
    description:
      "Compare Urban Solar Energy’s (>36 kVA) surplus buyback offer with other photovoltaic solar energy offers.",
  },
  OctopusEnergyPurchaseContractForIndividuals: {
    title:
      "SolarPlus Buyback Offer by Octopus Energy: Pricing & Terms",
    description:
      "Compare Octopus Energy’s Feed-in Tariff & optimization offer with other photovoltaic solar energy offers.",
  },
  // does not have a page
  OctopusEnergy: {
    title: "Octopus Energy for Commercial: Pricing & Terms",
    description:
      "Compare Octopus Energy’s Feed-in Tariff for Commercial with other photovoltaic solar energy offers.",
  },
  // does not have a page
  MintEnergy: {
    title: "Buyback by Mint Energy: Pricing & Terms",
    description:
      "Compare Mint Solaire’s solar surplus buyback with other photovoltaic solar energy offers.",
  },
  EkwateurSurplusWithContract: {
    title: "Sell to Ekwateur (with contract): Pricing & Terms",
    description:
      "Compare the Ekwateur Feed-in surplus buyback contract offer with other photovoltaic solar energy offers.",
  },
  EkwateurSurplusWithoutContract: {
    title: "Sell to Ekwateur (no contract): Pricing & Terms",
    description:
      "Compare the Ekwateur Feed-in surplus buyback offer with other photovoltaic solar energy offers.",
  },
  Kwatts: {
    title:
      "Purchase Contract by Kwatts at Market Price: Pricing & Terms",
    description:
      "Compare the Kwatts market price buyback offer, no subscription, at RTE price, with other photovoltaic solar energy offers.",
  },
  "3ERL": {
    title: "Purchase Contract by 3ERL at Market Price: Pricing & Terms",
    description:
      "Compare the 3E-RL balancing responsible offer at RTE price with other photovoltaic solar energy offers.",
  },
  JPMEEsurplusFixedForIndividuals: {
    title: "E-Surplus Fixed for Individuals (JPME): Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie fixed price surplus buyback offer with other solar energy offers.",
  },
  JPMEEsurplusFlexForIndividuals: {
    title: "E-Surplus Flex for Individuals (JPME): Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie market price buyback offer with other solar energy offers.",
  },
  JPMEEsurplusFixedForProfessionals: {
    title: "E-Surplus Fixed for Professionals (JPME): Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie fixed price surplus buyback offer with other solar energy offers.",
  },
  JPMEEsurplusFlexForProfessionals: {
    title: "E-Surplus Flex for Professionals (JPME): Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie market price buyback offer with other solar energy offers.",
  },
  JPMEEbatteryIndividualsLessThan15KVA: {
    title: "E-battery by JPME for Individuals: Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie virtual battery offer (up to 15 kVA) with other photovoltaic solar energy offers.",
  },
  JPMEEbatteryIndividualsThreePhase: {
    title: "E-battery by JPME for Individuals: Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie virtual battery (three-phase) offer with other photovoltaic solar energy offers.",
  },
  JPMEEbatteryLowVoltage: {
    title: "Low Voltage JPME E-battery: Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie virtual battery offer (BT>36) with other photovoltaic solar energy offers.",
  },
  JPMEEbatteryHighVoltage: {
    title: "High Voltage JPME E-battery: Pricing & Terms",
    description:
      "Compare the Je Produis Mon Énergie virtual battery offer (HTA) with other photovoltaic solar energy offers.",
  },
  MKSurplusWithValidate: {
    title:
      "MK-surplus Purchase Contract by MonKitSolaire: Pricing & Terms",
    description:
      "Compare the MonKitSolaire production sale offer (with Consuel) with other photovoltaic solar energy offers.",
  },
  MKSurplusWithoutValidate: {
    title:
      "MK-surplus Purchase Contract by MonKitSolaire: Pricing & Terms",
    description:
      "Compare the MonKitSolaire production sale offer (without Consuel) with other photovoltaic solar energy offers.",
  },
  Sunology: {
    title: "Surplus+ by Sunology: Pricing & Terms",
    description:
      "Compare the Sunology fixed-price surplus buyback offer with other photovoltaic solar energy offers.",
  },
  ResaleAgreementEDFOA: {
    title: "EDF OA Mandatory Purchase 20 Years (S21): Pricing & Terms",
    description:
      "Compare the government-guaranteed feed-in tariff in mainland France or overseas with other photovoltaic solar energy offers.",
  },
  ResaleAgreementTotalEnergies: {
    title:
      "Mandatory Purchase Rate by Total Energies: Pricing & Terms",
    description:
      "Compare the non-mandatory purchase contract offer by the energy supplier with other photovoltaic solar energy offers.",
  },
  OhmEnergie: {
    title:
      "Ohm Virtual Battery by Energy Supplier: Pricing & Terms",
    description:
      "Compare the unlimited, no hardware, Ohm virtual battery offer with other photovoltaic solar energy offers.",
  },
  InstallerDirectory: {
    title:
      "Find your RGE Certified Installer | Solar Directory | projetsolaire.com",
    description:
      "Choose a local professional. Reduce your electricity bill with cutting-edge solar panels and batteries.",
  },
  InstallerDirectoryDepartmentSelect: {
    title:
      "Find your RGE Certified Installer | Solar Directory | projetsolaire.com",
    description:
      "Choose a local professional. Reduce your electricity bill with cutting-edge solar panels and batteries.",
  },
  InstallerDirectoryDepartmentResults: {
    title:
      "Solar Panel Installers in {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Choose a local professional. Reduce your electricity bill with cutting-edge solar panels and batteries.",
  },
  InstallerDirectoryInstallerProfile: {
    title:
      "{commercialName} in {departmentName} ({departmentCode}): Reviews & Contact | projetsolaire.com",
    description:
      "Choose a local professional. Reduce your electricity bill with cutting-edge solar panels and batteries.",
  },
  MarketplacePartnerHome: {
    title:
      "Marketplace Partners",
    description:
      "Join our photovoltaic partner marketplace. Connect with solar professionals and grow your business.",
  },
  MarketplaceHome: {
    title:
      "New Solar Leads & PV Projects | Solar Marketplace | projetsolaire.com",
    description:
      "Discover new solar installation leads and photovoltaic projects in France. Connect with qualified clients looking for professional installers.",
  },
  MarketplaceTenderDetails: {
    title:
      "New Solar Lead {size}kWc in {location} | projetsolaire.com",
    description:
      "Solar installation project {size}kWc available in {location}. Connect with this qualified lead and grow your PV business today.",
  },
};
